export default __webpack_public_path__ + "static/media/locationsActive.42c3d0b6.svg";